


function sectionRedering(callback) {
  fetch("?section_id=cart-drawer")
    .then((res) => res.text())
    .then((data) => {
      var cart__html = $(data);
      var render__html = $(".drawer_top_sticky", cart__html);
      $(".drawer_top_sticky").replaceWith(render__html);
      var render__html = $(".cart__count-down-wrap", cart__html);
      $(".cart__count-down-wrap").replaceWith(render__html);
      var render__html = $(".my-cart__info", cart__html);
      $(".my-cart__info").replaceWith(render__html);
      var render__html = $(".drawer__cart-subtotal-end", cart__html);
      $(".drawer__cart-subtotal-end").replaceWith(render__html);
      var render__html = $(".drawer__cart-total-price", cart__html);
      $(".drawer__cart-total-price").replaceWith(render__html);


      cartSlider();
      initSidecartTimer();
      // defaultCheckFreeproduct();
      handleFreeGiftLogic();

      if (typeof callback === "function") {
        callback();
      }
    });

  fetch("?section_id=header")
    .then((res) => res.text())
    .then((data) => {
      const cart__html = $(data);
      const render__html = $(".header__right-cart span", cart__html);
      $(".header__right-cart span").replaceWith(render__html);
    });
}




function handleFreeGiftLogic() {
  const FREE_PRODUCT_VARIANT_ID = 51875152855386;
  const goal__price = $(".second-milestone .milestone-label").attr("data-shipping-goal");
  console.log(goal__price);
  const GIFT_THRESHOLD = goal__price; // 400.00 in Shopify's cents format

  $.getJSON("/cart.js", function (cart) {
    const cartTotal = cart.total_price;
    const hasFreeProduct = cart.items.some(item => item.id === FREE_PRODUCT_VARIANT_ID);

    // ✅ Add free product if total is 400+ and it's not already added
    if (cartTotal >= GIFT_THRESHOLD && !hasFreeProduct) {
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: {
          items: [{
            id: FREE_PRODUCT_VARIANT_ID,
            quantity: 1
          }]
        },
        success: function () {
          console.log("🎁 Free gift added.");
          sectionRedering();
        },
        error: function (err) {
          console.error("Error adding free product:", err.responseText);
        }
      });
    }

    // ❌ Remove free product if total < 400 and it's in the cart
    if (cartTotal < GIFT_THRESHOLD && hasFreeProduct) {
      const item = cart.items.find(item => item.id === FREE_PRODUCT_VARIANT_ID);

      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        data: {
          line: cart.items.findIndex(i => i.id === FREE_PRODUCT_VARIANT_ID) + 1,
          quantity: 0
        },
        success: function () {
          console.log("🗑️ Free gift removed.");
          sectionRedering();
        },
        error: function (err) {
          console.error("Error removing free product:", err.responseText);
        }
      });
    }
  });
}















// function cartSlider() {
//   if ($(Window).width() < 768) {
//     $('.mask').slick({
//       dots: true,
//       slidesToShow: 2,
//       slidesToScroll: 2,
//       arrows: false,
//       infinite: false

//     });
//   }
// }
// cartSlider()



function initSidecartTimer() {
  var timerContainer = document.querySelector('.sidecart-timer-container');
  if (!timerContainer) return;
  if (timerContainer.dataset.timerRunning === '1') return; // already ticking, avoid duplicate intervals
  timerContainer.dataset.timerRunning = '1';

  var startDateAttr = timerContainer.getAttribute('data-start-date');
  var finishDateAttr = timerContainer.getAttribute('data-finish-date');

  var now = new Date();

  // Configured dates (format MM-DD-YYYY HH:mm). May be empty, invalid, or past.
  var startDate = startDateAttr ? new Date(startDateAttr.replace(/-/g, '/')) : null;
  var finishDate = finishDateAttr ? new Date(finishDateAttr.replace(/-/g, '/')) : null;

  // Rolling fallback: when the configured finish date is missing, unparsable,
  // or already past, count down to the upcoming Sunday 23:00 (matches the
  // "valable jusqu'à dimanche" label). Guarantees a live timer, never NaN.
  if (!finishDate || isNaN(finishDate.getTime()) || finishDate <= now) {
    finishDate = new Date(now);
    var daysUntilSunday = (7 - now.getDay()) % 7; // 0 = today already Sunday
    finishDate.setDate(now.getDate() + daysUntilSunday);
    finishDate.setHours(23, 0, 0, 0);
    if (finishDate <= now) {
      finishDate.setDate(finishDate.getDate() + 7); // past Sunday 23h -> next week
    }
  }

  // Only hide before an explicit, valid, future start date.
  if (startDate && !isNaN(startDate.getTime()) && now < startDate) {
    timerContainer.style.display = 'none';
    return;
  }

  var timerInterval = null;

  function updateCountdown() {
    var now = new Date();
    var timeLeft = finishDate - now;

    if (timeLeft <= 0) {
      try {
        timerContainer.querySelector('.sidecart-timer-container__timer--days-amount').textContent = '00';
        timerContainer.querySelector('.sidecart-timer-container__timer--hours-amount').textContent = '00';
        timerContainer.querySelector('.sidecart-timer-container__timer--minutes-amount').textContent = '00';
        timerContainer.querySelector('.sidecart-timer-container__timer--seconds-amount').textContent = '00';
      } catch(e){}
      if (timerInterval) clearInterval(timerInterval);
      return;
    }

    var days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
    var hours = Math.floor((timeLeft / (1000 * 60 * 60)) % 24);
    var minutes = Math.floor((timeLeft / (1000 * 60)) % 60);
    var seconds = Math.floor((timeLeft / 1000) % 60);

    try {
      timerContainer.querySelector('.sidecart-timer-container__timer--days-amount').textContent = String(days).padStart(2, '0');
      timerContainer.querySelector('.sidecart-timer-container__timer--hours-amount').textContent = String(hours).padStart(2, '0');
      timerContainer.querySelector('.sidecart-timer-container__timer--minutes-amount').textContent = String(minutes).padStart(2, '0');
      timerContainer.querySelector('.sidecart-timer-container__timer--seconds-amount').textContent = String(seconds).padStart(2, '0');
    } catch(e){}
  }

  updateCountdown();
  timerInterval = setInterval(updateCountdown, 1000);
}


function ensureSidecartTimer() {
  try { initSidecartTimer(); } catch (e) {}
}

// Run as soon as possible. On heavy app pages (PageFly) product.js may execute
// AFTER DOMContentLoaded has already fired, so a plain listener would never run.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ensureSidecartTimer);
} else {
  ensureSidecartTimer();
}

// Re-attempt for cart drawers injected/rerendered late (AJAX cart, app builders).
[400, 1200, 2500].forEach(function (d) { setTimeout(ensureSidecartTimer, d); });

// Re-init each time the side cart is opened (the drawer markup can be re-rendered
// by the AJAX cart, producing a fresh, uninitialised timer node).
try {
  var _sidecartObserver = new MutationObserver(function () {
    if (document.body.classList.contains('open-cart-drawer')) ensureSidecartTimer();
  });
  _sidecartObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
} catch (e) {}












//   // match variant

function matchVariant() {
  var updateValue = "";
  $(".main-product__variant input[type='radio']:checked").each(function () {
    updateValue += (updateValue ? " / " : "") + $(this).val();
  });


  var isMatchFound = false;
  $(".select__variant option").each(function () {
    var optionValue = $(this).text().trim();
    if (updateValue.toLowerCase() === optionValue.toLowerCase()) {
      isMatchFound = true;
      $(this).prop("selected", true); // Trigger change if needed
    }
  });
  return true;


}


$(".main-product__variant input[type='radio']").change(function () {
  matchVariant();
})

$(document).ready(function () {
  matchVariant();
});



function matchVariantFeatured() {
  var updateValue = "";
  $(".product__right-wrap input[type='radio']:checked").each(function () {
    updateValue += (updateValue ? " / " : "") + $(this).val();
  });


  var isMatchFound = false;
  $(".select__variant option").each(function () {
    var optionValue = $(this).text().trim();
    if (updateValue.toLowerCase() === optionValue.toLowerCase()) {
      isMatchFound = true;
      $(this).prop("selected", true); // Trigger change if needed
    }
  });
  return true;


}


$(".product__right-wrap input[type='radio']").change(function () {
  matchVariantFeatured();
})

$(document).ready(function () {
  matchVariantFeatured();
});







$(".main-product__addTo").on("click", function (e) {
  e.preventDefault();

  formData = $(this).closest(".single__product-add-pro").serialize();
  addToCart(formData)
})


function addToCart(formData) {
  console.log(formData);
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: formData,
    success: function (data) {
      $("body").addClass("open-cart-drawer");
      sectionRedering();

    },
    error: function (err) {
      console.log(err);
    },
  });
}





// A $( document ).ready() block.
$(document).ready(function () {

  $(".upsell_main a").on("click", function (e) {
    e.preventDefault();
    var variantId = $(this).attr('data-product-id');
    console.log(variantId)
    var data = {
      id: variantId,
      quantity: 1
    };


    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function (response) {
        sectionRedering();
      },
      error: function (err) {
        console.log("Error adding product to cart:", err);
      }
    });
  });



  $(".main-product__upsell-action a, .sticky__right a").on("click", function (e) {
    e.preventDefault();
    var variantId = $(this).attr('data-product-id');
    console.log(variantId)
    var data = {
      id: variantId,
      quantity: 1
    };


    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function (response) {
        $("body").addClass("open-cart-drawer");
        sectionRedering();
      },
      error: function (err) {
        console.log("Error adding product to cart:", err);
      }
    });
  });
});




function addToCartProduct(event, el) {
  event.preventDefault();
  var variantId = $(el).attr('data-product-id');
  console.log(variantId)
  var data = {
    id: variantId,
    quantity: 1
  };


  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    dataType: "json",
    success: function (response) {
      $("body").addClass("open-cart-drawer");
      sectionRedering();
    },
    error: function (err) {
      console.log("Error adding product to cart:", err);
    }
  });

}





// increment quantity in cart drawer
function increment(el) {
  var input = el.previousElementSibling;
  var value = parseInt(input.value);
  console.log(value)
  value = isNaN(value) ? 0 : value
  value++;
  input.value = value;
  changeQuantityCart(input);

}
// decrement quantity in cart drawer
function decrement(el) {
  var input = el.nextElementSibling;
  var value = parseInt(input.value);
  if (value > 0) {
    value = isNaN(value) ? 0 : value;
    value--;
    input.value = value;
    changeQuantityCart(input);
  }
}

function changeQuantityCart(input) {

  var quantity = $(input).val();
  var data_line = $(input).attr("data-line");
  var data = {
    "line": data_line,
    "quantity": quantity
  };
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: data,
    success: function (data) {
      console.log(data);
      sectionRedering();
    },
    error: function (err) {
      console.log("Error from quantity update")
    }
  })


}



// function removeItem(event, el) {
//   event.preventDefault();
//   var data_line = $(el).attr("data-line");
//   console.log(data_line)
//   var deleteData = {
//     "line": data_line,
//     "quantity": 0
//   };

//   $.ajax({
//     type: "POST",
//     url: "/cart/change.js",
//     dataType: "json",
//     data: deleteData,
//     success: function (data) {

//       sectionRedering();
//     }
//   })
// }

// Add event listeners to the increment and decrement buttons






// shipping protect product add js start hrere

// $(document).ready(function () {
//   // ✅ Check checkbox on page load (or drawer open)
//   function updateInsuranceCheckboxState() {
//     $.getJSON('/cart.js', function (cart) {
//       cart.items.forEach(item => {
//         // Select checkbox that matches variant ID
//         $(`.insurance__switch-wrapper input[type='checkbox'][value='${item.id}']`).prop("checked", true);
//       });
//     });
//   }

//   // ✅ When checkbox is toggled
//   $(document).on("change", ".insurance__switch-wrapper input[type='checkbox']", function () {
//     const variantId = parseInt($(this).val());

//     if ($(this).is(":checked")) {
//       // Add item to cart
//       $.ajax({
//         type: "POST",
//         url: "/cart/add.js",
//         dataType: "json",
//         data: {
//           items: [{ id: variantId, quantity: 1 }]
//         },
//         success: function () {
//           sectionRedering(); // your own re-render logic
//           updateInsuranceCheckboxState(); // always update checkbox state
//         },
//         error: function (err) {
//           console.error("Error adding shipping protection:", err);
//         }
//       });
//     } else {
//       // Remove item from cart
//       $.getJSON('/cart.js', function (cart) {
//         const itemIndex = cart.items.findIndex(item => item.id === variantId);
//         if (itemIndex !== -1) {
//           const line = itemIndex + 1;
//           $.ajax({
//             type: "POST",
//             url: "/cart/change.js",
//             dataType: "json",
//             data: {
//               line: line,
//               quantity: 0
//             },
//             success: function () {
//               sectionRedering();
//               updateInsuranceCheckboxState();
//             },
//             error: function (err) {
//               console.error("Error removing shipping protection:", err);
//             }
//           });
//         }
//       });
//     }
//   });

//   // ✅ Initial checkbox check on load
//   updateInsuranceCheckboxState();
// });





// function removeItem(event, el) {
//   event.preventDefault();
//   var data_line = $(el).attr("data-line");

// const itemId = item?.id;

//     var deleteData = {
//       "line": data_line,
//       "quantity": 0
//     };

//     $.ajax({
//       type: "POST",
//       url: "/cart/change.js",
//       dataType: "json",
//       data: deleteData,
//       success: function (data) {
//         sectionRedering();
//       },
//       error: function (err) {
//         console.error("Error removing item:", err);
//       }
//     });
//   // });
// }


function removeItem(event, el) {
  event.preventDefault();

  const data_line = $(el).attr("data-line");
  const itemId = $(el).attr("data-item-id");

  // Your shipping protection product ID
  const shippingProtectionId = "50674196414810";

  // Check if the removed item is the shipping protection product
  const isShippingProtection = itemId === shippingProtectionId;

  const deleteData = {
    "line": data_line,
    "quantity": 0
  };

  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: deleteData,
    success: function (data) {
      if (isShippingProtection) {
        defaultCheckFreeproduct();
      }
      sectionRedering();
    },
    error: function (err) {
      console.error("Error removing item:", err);
    }
  });
}



// $(".insurance__switch-wrapper input[type='checkbox']").on("change", function () {
//   const productId = $(this).val();

//   if ($(this).is(":checked")) {
//     $.ajax({
//       type: "POST",
//       url: "/cart/add.js",
//       dataType: "json",
//       data: {
//         items: [{
//           id: productId,
//           quantity: 1
//         }]
//       },
//       success: function (data) {
//         sectionRedering();
//       },
//       error: function (err) {
//         console.error("Error adding shipping protection:", err);
//       }
//     });
//   } else {
//     $.getJSON('/cart.js', function (cart) {
//       const itemIndex = cart.items.findIndex(item => item.id == productId);
//       if (itemIndex !== -1) {
//         const line = itemIndex + 1;
//         $.ajax({
//           type: "POST",
//           url: "/cart/change.js",
//           dataType: "json",
//           data: {
//             line: line,
//             quantity: 0
//           },
//           success: function (data) {
//             console.log(data);
//             sectionRedering();
//           },
//           error: function (err) {
//             console.error(err);
//           }
//         });
//       } else {
//         console.error("Item not found in the cart.");
//       }
//     });
//   }
// });




function bindInsuranceSwitchHandler() {
  $(document).off("change", ".insurance__switch-wrapper input[type='checkbox']");

  $(document).on("change", ".insurance__switch-wrapper input[type='checkbox']", function () {
    const productId = $(this).val();
    const $checkbox = $(this);

    if ($checkbox.is(":checked")) {


      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: {
          items: [{
            id: productId,
            quantity: 1
          }]
        },
        success: function () {
          sectionRedering(() => {
            // ✅ Re-check the box and add class AFTER re-render
            $(`.insurance__switch-wrapper input[value='${productId}']`)
              .prop("checked", true)
              .addClass("active-toggle");
          });
        }
        ,
        error: function (err) {
          console.error("Error adding shipping protection:", err);
        }
      });

    } else {


      $.getJSON('/cart.js', function (cart) {
        const itemIndex = cart.items.findIndex(item => item.id == productId);
        if (itemIndex !== -1) {
          const line = itemIndex + 1;
          $.ajax({
            type: "POST",
            url: "/cart/change.js",
            dataType: "json",
            data: {
              line: line,
              quantity: 0
            },
            success: function () {
              sectionRedering();

              // Re-uncheck the box after redraw
              setTimeout(() => {
                $(`.insurance__switch-wrapper input[value='${productId}']`)
                  .prop("checked", false)
                  .removeClass("active-toggle");
              }, 300);
            },
            error: function (err) {
              console.error(err);
            }
          });
        }
      });
    }
  });
}

$(document).ready(function () {

  bindInsuranceSwitchHandler();
  defaultCheckFreeproduct();
});







function defaultCheckFreeproduct() {
  const shippingProtectionId = $("#insuranceCheckbox").val();

  $.getJSON('/cart.js', function (cart) {
    const shippingProtectionItem = cart.items.find(item => item.id == parseInt(shippingProtectionId));

    const $checkbox = $(`.insurance__switch-wrapper input[value='${shippingProtectionId}']`);

    if (shippingProtectionItem) {
      $checkbox.prop("checked", true).addClass("active-toggle");
    } else {
      $checkbox.prop("checked", false).removeClass("active-toggle");
    }
  });
}










// shipping protect product add js end hrere

















function cartSlider() {
  var $slider = $('.upsell__product-wraps');
  if (!$slider.length) return;

  // Check if slick is available before calling it
  if (typeof $.fn.slick !== 'function') return;

  var isVisible = $slider.is(':visible');
  var hasChildren = $slider.children().length > 0;
  var hasWidth = $slider[0] && $slider[0].getBoundingClientRect().width > 0;

  if (
    $(window).width() < 768 &&
    isVisible &&
    hasChildren &&
    hasWidth &&
    !$slider.hasClass('slick-initialized')
  ) {
    try {
      $slider.slick({
        dots: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: false,
        infinite: false
      });
    } catch(e) {
      console.warn('[Elevaine] Slick slider not available for upsell:', e.message);
    }
  }
}

// cartSlider()


// After showing the cart
$('.custom_upsell').on('transitionend', function () {
  cartSlider();
});